// axios
import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';

const baseURL = '';

export default axios.create({
  baseURL: baseURL,
  // You can add your headers here
  headers: { 'Cache-Control': 'no-cache' },
  // cache will be enabled by default
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
});
